/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 42,
    height: 32,
    viewBox: '0 0 42 32',
    data: '<path pid="0" _fill="#757575" d="M40.774 14.452H5.285L17.094 2.643A1.548 1.548 0 1014.907.454l-.001.001L.454 14.907c-.144.135-.256.3-.327.487l-.003.009a1.507 1.507 0 00.003 1.124l-.004-.01c.074.195.187.361.33.495l.001.001 14.452 14.452c.28.28.667.453 1.094.453s.814-.173 1.094-.453c.28-.28.453-.667.453-1.094s-.173-.814-.453-1.094L5.285 17.551h35.489a1.548 1.548 0 100-3.096z"/>'
  }
})
